
import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Header from "./components/Header";
import AppRoutes from "./routes";
import ActivityTracker from "./components/ActivityTracker";
import AnnouncementPopup from "./components/AnnouncementPopup";
import { BranchProvider } from "./context/BranchContext";
import "./index.css";
import "leaflet/dist/leaflet.css";

function AppShell() {
  const location = useLocation();
  const showHeader = location.pathname !== "/login";
  // Header is shown on all pages except login. Chatbot will be rendered via routing.


  return (
    <div className="app-shell">
      <ActivityTracker />
      {showHeader && <Header />}
      <AnnouncementPopup />
      <div className="app-body">
        <main className="app-content">
          <AppRoutes />
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <BranchProvider>
        <AppShell />
      </BranchProvider>
    </BrowserRouter>
  );
}

export default App;
